import { Role } from '@global/types'
import { RootState } from 'redux/store'

export function selectIsUserAdmin(state: RootState) {
  return state.Auth.user?.role === Role.OWNER
}

export enum FeatureDict {
  APPROVAL = 'approval',
  CHIPS_LIST = 'ui-chips-list',
  CREATIVE_CLASSIFICATION = 'creative_classification',
  DATA_STANDARDS_DASHBOARD = 'data-standards-dashboard',
  DATASET_DETAILS_API_DEBUG = 'dataset-details-api-debug',
  DATASETS_PAGE = 'datasets-page',
  ENABLE_AUTO_SUBMIT = 'enable-auto-submit',
  IMAGE_PREVIEW = 'image-preview',
  LIST_IMPORT_EXPORT = 'list-import-export',
  LISTS_AS_DATASETS = 'lists-as-datasets',
  NEW_SUBMISSION_HISTORY_UI = 'new-submission-history-ui',
  OAUTH_ADOBE_CONNECTOR = 'oauth-adobe-connector',
  RERUN_INTEGRATIONS_ENABLED = 'rerun-integrations-button',
  SCD_ROLLUP = 'scd-rollup',
  SHOW_DATA_SOURCE = 'show-data-source',
  TEXT_SELECTION_OUTBOUND = 'text-selection-outbound',
  TAXONOMY_TRANSLATION_MAPPING = 'taxonomy-translation-mapping',
  SSO_LOGOUT = 'sso-logout',
  PERFORMANCE_METRICS = 'performance-metrics',
  MANAGER_APPROVALS = 'manager-approval',
  USER_ACTIVITY_LOG = 'user-activity-log',
  ENABLE_LIVEBLOCKS = 'enable-liveblocks',
  CLARAVINE_AGENT = 'claravine-agent',
  ERROR_CORRECTION = 'error-correction',
  ROW_PROPERTIES_OUTBOUND = 'row-properties-outbound',
  DATA_RELATIONSHIP = 'data-relationship',
  DELETE_FROM_ROLLUP = 'delete-from-rollup',
  USE_AIMIA_FOR_SFTP_PUSH = 'use-aimia-for-sftp-push',
  CAMPAIGN_HEALTH = 'campaign-health',
  GEN_AI = 'generative-ai-features',
}

// value may be a string containing "false"
export function toBoolean(val: string | boolean | undefined) {
  return typeof val === 'string' && val === 'false' ? false : Boolean(val)
}

export function selectFeatureIncludes(features: FeatureDict[]) {
  return (state: RootState) =>
    Object.values(features).map(feature => toBoolean(state.Auth.features[feature]))
}
